module.exports = __webpack_public_path__ + "static/img/03024A_4_R_20200518_fit.df4005a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/03024A_4_R_20200518_fit.png
// module id = Ai+t
// module chunks = 0